import React,{Component} from 'react';

require('dotenv').config();

class Copyright extends Component {
    render() {
        return (
            <span>Copyright © 2020 Fresh Factory. All rights reserved</span>
        )
    }
}

export default Copyright;